module.exports = __webpack_public_path__ + "img/app-store.ded659fb.svg";